import PropTypes from 'prop-types';

module.exports = {
  contextTypes: {
    showAppPopover: PropTypes.func,
    showAppPopoverObject: PropTypes.func,
    hideAppPopover: PropTypes.func
  },


  getPopoverPoint(targetElement, direction){
    if (!targetElement) return;
    var elementRect = targetElement.getBoundingClientRect();
    var coordinates = {
      clientX: elementRect.left,
      clientY: elementRect.bottom
    };

    switch (direction) {
      case "bottom":
        coordinates.clientX += elementRect.width / 2;
        break;
      case "left":
        coordinates.clientY -= elementRect.height / 2;
        break;
      case "right":
        coordinates.clientX += elementRect.width;
        coordinates.clientY -= elementRect.height / 2;
        break;
      case "top":
      default:
        coordinates.clientX += elementRect.width / 2;
        coordinates.clientY -= elementRect.height;
    }

    return coordinates;
  }
};
